import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h1", {
    class: "modal-title fs-5",
    id: "deleteModalLabel"
  }, "Delete exercises"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to delete the selected exercises?")
], -1)
const _hoisted_5 = { class: "modal-footer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-danger",
          "data-bs-dismiss": "modal",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete-exercises', _ctx.selectedExercises)))
        }, " Delete " + _toDisplayString(_ctx.selectedExercises.length) + " exercise(s) ", 1)
      ])
    ])
  ]))
}